import { render, staticRenderFns } from "./SinisterDates.vue?vue&type=template&id=1176577a"
import script from "./SinisterDates.vue?vue&type=script&lang=js"
export * from "./SinisterDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/SinisterDates.vue
// module id = 1065
// module chunks = 31